import { IInsuranceCoverageMonitorSettings } from "./types";
import { monitorSettingsService } from "./service";

export const getMonitorSettingsItem = async (
  monitoredSettingsId: string
): Promise<IInsuranceCoverageMonitorSettings> => {
  const { data } =
    await monitorSettingsService.get<IInsuranceCoverageMonitorSettings>(
      `/${monitoredSettingsId}`
    );

  return data;
};
